/* HWD Bildpipeline fuer die Gravur-Konfiguratoren

   Getrennt von der Oberflaeche, damit die Bildmathematik fuer sich lesbar
   und testbar bleibt. Zwei Ausgaben, dieselbe Vorbereitung:

   grauAuflage - Fotogravur auf Holz. Das Originalfoto in Schwarz-Weiss,
     gelegt als Brandauflage: dunkle Bildstellen decken das Holz zu
     (= graviert), helle lassen es durchscheinen (= unbehandelt). Ein
     gerastertes Vorschaubild waere technisch ehrlicher, aber der Kunde
     erkennt sein Foto darin kaum wieder - er saehe Punkte statt Gesichter.

   silhouette - Motive, Logos und Scherenschnitte, etwa auf dem Zippo. Dort
     gibt es keine Grautoene: entweder der Lack ist weg oder er ist da.
     Gerechnet wird deshalb eine harte Maske mit weicher Kante, entweder
     aus der Transparenz der Datei (Logo mit Freisteller) oder ueber einen
     Helligkeitsschwellwert. Die Farbe der Auflage bestimmt der Aufrufer -
     auf Holz dunkel, auf lackiertem Metall hell.

   Aufloesung: gerechnet wird in der Groesse, in der das Bild auf dem
   Bildschirm oder im Beleg erscheint, gedeckelt auf MAX_AUFLAGE.

   Object-URLs statt Data-URLs: ein 6-MB-Foto bleibt 6 MB und wird nicht als
   8-MB-Zeichenkette im Speicher gehalten.
*/
window.HWDBild = (function () {
  'use strict';

  var MAX_ARBEIT = 1600;      // laengste Kante der Arbeitskopie in Pixeln
  var MAX_VEKTOR = 1800;      // Vektordateien werden auf diese Kante gerastert
  var MAX_AUFLAGE = 2200;     // laengste Kante der fertigen Auflage
  var BRENNFARBE = [62, 40, 22];

  function leinwand(b, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(b));
    c.height = Math.max(1, Math.round(h));
    return c;
  }

  /* ---------- Laden ---------- */
  function ladeDatei(datei) {
    return new Promise(function (erfolg, fehler) {
      var url = URL.createObjectURL(datei);
      var img = new Image();
      img.onload = function () {
        if (!img.naturalWidth) { URL.revokeObjectURL(url); fehler(new Error('leer')); return; }
        erfolg({ img: img, url: url, b: img.naturalWidth, h: img.naturalHeight });
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        fehler(new Error('dekodieren'));
      };
      img.src = url;
    });
  }

  /* Verkleinerte Arbeitskopie. Alle Filter laufen darauf, nie auf dem
     Original. Vektordateien werden umgekehrt vergroessert gerastert - sie
     haben oft nur eine winzige Eigengroesse, verlieren dabei aber nichts. */
  function arbeitskopie(img, vektor) {
    var lang = Math.max(img.naturalWidth, img.naturalHeight);
    var f;
    if (vektor) f = MAX_VEKTOR / lang;
    else f = lang > MAX_ARBEIT ? MAX_ARBEIT / lang : 1;
    var c = leinwand(img.naturalWidth * f, img.naturalHeight * f);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c;
  }

  /* ---------- Tonwerte ---------- */
  function grenzen(daten, anteil) {
    var hist = new Uint32Array(256), i, summe = 0;
    for (i = 0; i < daten.length; i += 4) hist[daten[i]]++;
    var gesamt = daten.length / 4;
    var kappe = gesamt * anteil;
    var min = 0, max = 255;
    for (i = 0; i < 256; i++) { summe += hist[i]; if (summe > kappe) { min = i; break; } }
    summe = 0;
    for (i = 255; i >= 0; i--) { summe += hist[i]; if (summe > kappe) { max = i; break; } }
    if (max - min < 8) { min = 0; max = 255; }
    return { min: min, max: max };
  }

  /* Graustufen plus Korrekturen. Gibt eine neue Leinwand zurueck. */
  function verarbeite(quelle, opt) {
    opt = opt || {};
    var c = leinwand(quelle.width, quelle.height);
    var g = c.getContext('2d');
    g.drawImage(quelle, 0, 0);
    var bild = g.getImageData(0, 0, c.width, c.height);
    var p = bild.data, i;

    /* 1. Graustufen nach Helligkeitsempfinden */
    for (i = 0; i < p.length; i += 4) {
      var y = (p[i] * 0.2126 + p[i + 1] * 0.7152 + p[i + 2] * 0.0722) | 0;
      p[i] = p[i + 1] = p[i + 2] = y;
    }

    /* 2. Auto-Tonwert: die dunkelsten und hellsten halben Prozent abschneiden
          und den Rest auf den vollen Umfang ziehen. */
    if (opt.autoTonwert) {
      var gr = grenzen(p, 0.005);
      var spanne = gr.max - gr.min;
      for (i = 0; i < p.length; i += 4) {
        var v = (p[i] - gr.min) * 255 / spanne;
        v = v < 0 ? 0 : (v > 255 ? 255 : v);
        p[i] = p[i + 1] = p[i + 2] = v;
      }
    }

    /* 3. Helligkeit, Kontrast, Gamma */
    var hell = (opt.helligkeit || 0) * 2.55;          // -100..100
    var k = (opt.kontrast || 0) / 100;                 // -1..1
    var kf = (1 + k) * (1 + k);
    var gamma = opt.gamma && opt.gamma > 0 ? opt.gamma : 1;
    var tabelle = new Uint8Array(256);
    for (i = 0; i < 256; i++) {
      var w = i + hell;
      w = (w - 128) * kf + 128;
      if (gamma !== 1) w = 255 * Math.pow(Math.max(w, 0) / 255, 1 / gamma);
      tabelle[i] = w < 0 ? 0 : (w > 255 ? 255 : w);
    }
    for (i = 0; i < p.length; i += 4) {
      var t = tabelle[p[i]];
      p[i] = p[i + 1] = p[i + 2] = t;
    }
    g.putImageData(bild, 0, 0);

    /* 4. Schaerfen ueber eine einfache Faltung. Gravur lebt von Kanten. */
    if (opt.schaerfe > 0) schaerfen(c, opt.schaerfe / 100);
    return c;
  }

  function schaerfen(c, staerke) {
    var g = c.getContext('2d');
    var bild = g.getImageData(0, 0, c.width, c.height);
    var src = new Uint8ClampedArray(bild.data);
    var p = bild.data, b = c.width, h = c.height;
    var mitte = 1 + 4 * staerke, seite = -staerke;
    for (var y = 1; y < h - 1; y++) {
      for (var x = 1; x < b - 1; x++) {
        var i = (y * b + x) * 4;
        var v = src[i] * mitte
          + src[i - 4] * seite + src[i + 4] * seite
          + src[i - b * 4] * seite + src[i + b * 4] * seite;
        p[i] = p[i + 1] = p[i + 2] = v < 0 ? 0 : (v > 255 ? 255 : v);
      }
    }
    g.putImageData(bild, 0, 0);
  }

  function ziel(zielB, zielH) {
    var lang = Math.max(zielB, zielH);
    var f = lang > MAX_AUFLAGE ? MAX_AUFLAGE / lang : 1;
    return leinwand(zielB * f, zielH * f);
  }

  /* ---------- Brandauflage (Holz) ----------
     Aus dem Graustufenbild wird eine Auflage in Brennfarbe: die Deckkraft
     jedes Punktes ist der Kehrwert seiner Helligkeit. Schwarz deckt voll,
     Weiss gar nicht - darunter liegt das Holz. */
  function grauAuflage(quelle, zielB, zielH) {
    var c = ziel(zielB, zielH);
    var g = c.getContext('2d');
    g.drawImage(quelle, 0, 0, c.width, c.height);
    var bild = g.getImageData(0, 0, c.width, c.height);
    var p = bild.data;
    for (var i = 0; i < p.length; i += 4) {
      var y = p[i];
      p[i] = BRENNFARBE[0];
      p[i + 1] = BRENNFARBE[1];
      p[i + 2] = BRENNFARBE[2];
      p[i + 3] = 255 - y;          // dunkle Bildstellen = viel Brand
    }
    g.putImageData(bild, 0, 0);
    return c;
  }

  /* ---------- Silhouette (Motive, Logos) ----------
     Maske statt Tonwert: entweder aus der Transparenz der Datei - ein
     freigestelltes Logo bringt sie mit - oder ueber einen Schwellwert auf
     die Helligkeit. Die Kante bekommt eine schmale Rampe, sonst treppt sie
     sichtbar. opt.farbe ist die Gravurfarbe des jeweiligen Materials. */
  function silhouette(quelle, zielB, zielH, opt) {
    opt = opt || {};
    var farbe = opt.farbe || BRENNFARBE;
    var schwelle = opt.schwelle == null ? 128 : opt.schwelle;
    var rampe = 10;
    var c = ziel(zielB, zielH);
    var g = c.getContext('2d');
    g.drawImage(quelle, 0, 0, c.width, c.height);
    var bild = g.getImageData(0, 0, c.width, c.height);
    var p = bild.data, i;

    /* Hat die Datei Transparenz, ist sie die bessere Maske als die Helligkeit */
    var durchsichtig = false;
    for (i = 3; i < p.length; i += 40) { if (p[i] < 16) { durchsichtig = true; break; } }

    for (i = 0; i < p.length; i += 4) {
      var deckung;
      if (durchsichtig) {
        deckung = p[i + 3] / 255;
      } else {
        var y = p[i] * 0.2126 + p[i + 1] * 0.7152 + p[i + 2] * 0.0722;
        deckung = (schwelle + rampe - y) / (2 * rampe);
        deckung = deckung < 0 ? 0 : (deckung > 1 ? 1 : deckung);
      }
      if (opt.umkehren) deckung = 1 - deckung;
      p[i] = farbe[0];
      p[i + 1] = farbe[1];
      p[i + 2] = farbe[2];
      p[i + 3] = Math.round(deckung * 255);
    }
    g.putImageData(bild, 0, 0);
    return c;
  }

  return {
    ladeDatei: ladeDatei,
    arbeitskopie: arbeitskopie,
    verarbeite: verarbeite,
    grauAuflage: grauAuflage,
    silhouette: silhouette,
    MAX_ARBEIT: MAX_ARBEIT
  };
})();
